<ng-template #changePasswordModal let-params let-ref="modalRef">
  <p>Inserisci nei campi sottostanti la nuova password desiderata e la password corrente.</p>

  <p>La password deve:</p>
  <ul>
    <li>contenere almeno un carattere maiuscolo</li>
    <li>contenere almeno un carattere numerico</li>
    <li>contenere almeno un carattere speciale, ad es. #, $,%</li>
    <li>non deve contenere più di due caratteri identici consecutivi</li>
    <li>avere una lunghezza di almeno 8 caratteri</li>
    <li>non deve contenere informazioni non segrete riconducibili all'utente (nome, cognome, data di nascita, numero
      documento, numero di telefono, username, codice fiscale) </li>
  </ul>
  <!-- <p>È consigliato l'utilizzo di almeno un carattere speciale.</p> -->
  <nz-spin nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
    <form autocomplete="off" nz-form [formGroup]="validateForm" class="custom-form">
      <nz-form-item class="login">
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-form-control [nzErrorTip]="getValidationErrorMessage(validateForm.controls.oldPassword.errors)">
              <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="temporaryPasswordTemplate">
                <input [type]="temporaryPasswordVisible ? 'text' : 'password'" nz-input name="oldPassword"
                  placeholder="Password Corrente" formControlName="oldPassword" />
              </nz-input-group>
              <ng-template #temporaryPasswordTemplate>
                <i nz-icon [nzType]="temporaryPasswordVisible ? 'eye-invisible' : 'eye'"
                  (click)="temporaryPasswordVisible = !temporaryPasswordVisible"></i>
              </ng-template>
            </nz-form-control>
          </div>

        </div>
      </nz-form-item>
      <nz-form-item class="login">
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-form-control [nzErrorTip]="getValidationErrorMessage(validateForm.controls.newPassword.errors)">
              <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="newPasswordTemplate">
                <input [type]="newPasswordVisible ? 'text' : 'password'" nz-input name="newPassword"
                  formControlName="newPassword" placeholder="Nuova Password" />
              </nz-input-group>
              <ng-template #newPasswordTemplate>
                <i nz-icon [nzType]="newPasswordVisible ? 'eye-invisible' : 'eye'"
                  (click)="newPasswordVisible = !newPasswordVisible"></i>
              </ng-template>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <nz-form-item class="login">
        <div nz-row>
          <div nz-col nzSpan="24">
            <nz-form-control [nzErrorTip]="getValidationErrorMessage(validateForm.controls.confirmNewPassword.errors)">
              <nz-input-group nzPrefixIcon="lock" class="login" [nzSuffix]="confirmNewPasswordTemplate">
                <input [type]="confirmNewPasswordVisible ? 'text' : 'password'" nz-input name="confirmNewPassword"
                  formControlName="confirmNewPassword" placeholder="Conferma Nuova Password" />
              </nz-input-group>
              <div *ngIf="validateForm.errors?.passwordsDontMatch && (validateForm.touched || validateForm.dirty)"
                class="cross-validation-error-message alert"
                i18n="Generic.ValidationError.PasswordsDontMatch|Errore che si ha quando viene chiesto di digitare due volte la password e queste sono diverse@@Generic.ValidationError.PasswordsDontMatch">
                Le password devono coincidere
              </div>
              <ng-template #confirmNewPasswordTemplate>
                <i nz-icon [nzType]="confirmNewPasswordVisible ? 'eye-invisible' : 'eye'"
                  (click)="confirmNewPasswordVisible = !confirmNewPasswordVisible"></i>
              </ng-template>
            </nz-form-control>
          </div>
        </div>
      </nz-form-item>
      <div *ngIf="customError" nzJustify="center" nz-row>
        <div nz-col [nzSpan]="24">
          <div class="alert alert-danger">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <app-resend-otp class="padding"
        [disabled]="!validateForm.controls.oldPassword.valid || !validateForm.controls.newPassword.valid || !validateForm.controls.confirmNewPassword.valid || validateForm.errors?.passwordsDontMatch || timerService.otpSended"
        [validateForm]="validateForm"
        [errorTip]="getValidationErrorMessage(validateForm.controls.otpCode.errors)"
        (isSpinning)="activateSpin($event)"
      ></app-resend-otp>
    </form>
  </nz-spin>
</ng-template>

<ng-template #changePasswordFooter>
  <button nz-button nzType="primary" (click)="onModifyPasswordChange()" [disabled]="!validateForm.valid">INVIA</button>
</ng-template>
